import * as React from "react";
const SvgDiamond = (props) => /* @__PURE__ */ React.createElement("svg", { width: 5, height: 4, viewBox: "0 0 5 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 2.82861, y: -0.82843, width: 4, height: 4, rx: 2, transform: "rotate(45 2.82861 -0.82843)", fill: "#CFDDF1" }));
export default SvgDiamond;
